/**
 * Radio Component
 *
 * A reusable radio button component that follows the StartupHive design system.
 *
 * Props:
 * - label: string - label text (required)
 * - id: string - radio id (required for accessibility)
 * - name: string - radio name (required for grouping)
 * - value: string - radio value
 * - checked: boolean - controlled radio state
 * - onChange: function - change handler
 * - disabled: boolean
 * - className: additional CSS classes for wrapper
 * - ...rest: any other input attributes
 */

function Radio({
  label,
  id,
  name,
  value,
  checked,
  onChange,
  disabled = false,
  className = '',
  ...rest
}) {
  return (
    <div className={`form-radio ${className}`.trim()}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="radio"
        {...rest}
      />
      <label htmlFor={id} className="radio-label">
        {label}
      </label>
    </div>
  )
}

export default Radio
